import { applyMiddleware, compose, createStore } from "redux";
import createSagaMiddleware from "redux-saga";
import { persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { PERSIST_LEARNING_OBJECTIVES } from 'core/store/conf';

import { rootReducer, rootSaga } from "./rootDuck";

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const sagaMiddleware = createSagaMiddleware();
const store = createStore(
    rootReducer,
    composeEnhancers(applyMiddleware(sagaMiddleware))
);

/**
 * @see https://github.com/rt2zz/redux-persist#persiststorestore-config-callback
 * @see https://github.com/rt2zz/redux-persist#persistor-object
 */
export const persistor = persistStore(store);

(async () => {
    try {
        await storage.removeItem(`persist:${PERSIST_LEARNING_OBJECTIVES}`);
    } catch {
        // best-effort purge of orphaned key
    }
})();

sagaMiddleware.run(rootSaga);

export default store;
